const featuredMedia = [
  {
    type: "Podcast",
    outlet: "Varejo em Foco",
    logo: "ri-mic-2-line",
    title: "\"Como transformar vendedoras comuns em top performers — o Método CAT na prática\"",
    description: "Gleice Lyra explica como construiu um sistema replicável de performance para equipes de loja, abordando mentalidade, técnica e dados. Episódio tornou-se um dos mais ouvidos da plataforma.",
    date: "Março 2024",
    duration: "58 min",
    tag: "Podcast",
    tagColor: "bg-rose-50 text-rose-600 border border-rose-100",
    image: "https://readdy.ai/api/search-image?query=professional%20podcast%20studio%20with%20microphone%20golden%20warm%20lighting%20dark%20background%20modern%20audio%20equipment%20minimalist%20setup%20elegant%20atmosphere&width=600&height=380&seq=midia-podcast-01&orientation=landscape",
  },
  {
    type: "Entrevista",
    outlet: "Pequenas Empresas Grandes Negócios",
    logo: "ri-tv-2-line",
    title: "\"Gestão de varejo: como lojas pequenas podem competir com as grandes redes\"",
    description: "Em entrevista exclusiva, a especialista detalha as estratégias de sell-through, mix de produto e atendimento que aplicou ao longo de 28 anos para reverter resultados em dezenas de operações.",
    date: "Novembro 2023",
    duration: "22 min",
    tag: "TV / Online",
    tagColor: "bg-amber-50 text-amber-700 border border-amber-100",
    image: "https://readdy.ai/api/search-image?query=tv%20interview%20studio%20set%20elegant%20warm%20lighting%20professional%20business%20interview%20setup%20camera%20lights%20neutral%20background%20sophisticated%20broadcast%20environment&width=600&height=380&seq=midia-tv-01&orientation=landscape",
  },
];

const pressItems = [
  {
    outlet: "Estadão PME",
    quote: "\"Gleice Lyra prova que método e resultado andam juntos — e que equipe bem treinada é o maior ativo de uma loja.\"",
    date: "Ago 2023",
    icon: "ri-newspaper-line",
  },
  {
    outlet: "Sebrae Notícias",
    quote: "\"A especialista que está ajudando lojistas de todo o Brasil a bater metas com consistência e ciência.\"",
    date: "Jan 2023",
    icon: "ri-store-2-line",
  },
];

const speakingEvents = [
  { event: "Grupo Bittencourt", year: "2025", city: "São Paulo, SP" },
  { event: "Fórum Nacional de Varejo", year: "2024", city: "São Paulo, SP" },
  { event: "ABF Franchising Expo", year: "2023", city: "São Paulo, SP" },
  { event: "Retail Summit Brasil", year: "2023", city: "Curitiba, PR" },
  { event: "APAS Show", year: "2022", city: "São Paulo, SP" },
];

export default function NaMidia() {
  return (
    <section
      id="na-midia"
      className="py-20 px-6 md:px-16 bg-white border-t border-gray-100"
    >
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-[#b8962e] text-xs tracking-[0.3em] uppercase font-medium mb-4 border border-[#b8962e]/40 px-3 py-1">
            Na Mídia
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-black tracking-tight mb-3">
            Gleice Lyra e a <span className="font-semibold">Clientizah</span> em destaque
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto leading-relaxed">
            Referência reconhecida na imprensa especializada, em podcasts e nos principais eventos do varejo nacional.
          </p>
        </div>

        {/* Featured 2-column */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          {featuredMedia.map((item) => (
            <div
              key={item.outlet}
              className="group rounded-lg overflow-hidden border border-gray-100 bg-[#faf9f7] hover:border-[#b8962e]/30 transition-all duration-300"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.outlet}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${item.logo} text-[#b8962e] text-base`}></i>
                    </div>
                    <span className="text-xs font-semibold text-black tracking-wide uppercase">{item.outlet}</span>
                  </div>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm font-semibold text-black leading-snug mb-2 italic">
                  {item.title}
                </p>
                <p className="text-xs text-gray-500 leading-relaxed mb-4">
                  {item.description}
                </p>
                <div className="flex items-center gap-4 text-[11px] text-gray-400">
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-calendar-line"></i>
                    </span>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-time-line"></i>
                    </span>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Press quotes grid */}
        <div className="mb-14">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-400 text-center mb-8">
            O que a imprensa diz
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {pressItems.map((p) => (
              <div
                key={p.outlet}
                className="bg-[#faf9f7] rounded-lg px-5 py-5 border border-gray-100 hover:border-[#b8962e]/30 transition-all duration-300"
              >
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#b8962e]/10">
                    <i className={`${p.icon} text-[#b8962e] text-sm`}></i>
                  </div>
                  <span className="text-xs font-bold text-black tracking-wide uppercase">{p.outlet}</span>
                  <span className="ml-auto text-[10px] text-gray-400 whitespace-nowrap">{p.date}</span>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed italic">{p.quote}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Speaking events + CTA strip */}
        <div className="flex flex-col lg:flex-row gap-8 items-stretch">

          {/* Speaking events */}
          <div className="flex-1 bg-[#faf9f7] rounded-lg border border-gray-100 px-7 py-7">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-presentation-line text-[#b8962e] text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-black tracking-tight uppercase">Palestras & Eventos</h3>
            </div>
            <ul className="space-y-3">
              {speakingEvents.map((ev) => (
                <li key={ev.event} className="flex items-center justify-between border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                  <div>
                    <p className="text-xs font-medium text-black">{ev.event}</p>
                    <p className="text-[10px] text-gray-400 mt-0.5">{ev.city}</p>
                  </div>
                  <span className="text-xs text-[#b8962e] font-semibold whitespace-nowrap ml-4">{ev.year}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA box */}
          <div
            className="lg:w-80 rounded-lg overflow-hidden relative flex flex-col justify-end"
            style={{ minHeight: "260px" }}
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage:
                  "url(https://readdy.ai/api/search-image?query=modern%20retail%20store%20interior%20warm%20golden%20lighting%20elegant%20boutique%20fashion%20store%20shelves%20products%20elegant%20minimal%20atmosphere%20sophisticated%20ambiance&width=640&height=520&seq=midia-cta-01&orientation=portrait)",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />
            <div className="relative z-10 p-7">
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#b8962e] font-medium mb-2">Método CAT</p>
              <p className="text-white text-base font-semibold leading-snug mb-4">
                Aprenda com quem já fez o curso em todo o Brasil.
              </p>
              <a
                href="#inscricao"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("inscricao")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-block bg-[#b8962e] text-white text-xs tracking-widest uppercase font-medium px-5 py-2.5 rounded-md hover:bg-[#9e7e25] transition-colors cursor-pointer whitespace-nowrap"
              >
                Quero me inscrever
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
